<template>
    <div>
        <Steps
            :current="statusIndex"
            class="bg-fff padding-top-15 padding-bottom-15"
            v-if="querytype == 'query'"
        >
            <Step
                v-for="val of getStatus"
                :title="val.label"
                :key="val.value"
            ></Step>
        </Steps>
        <div v-if="querytype == 'priceA'" class="text-right margin-right-15">
            <vButton
                class="margin-right-20 margin-bottom-10"
                theme="primary"
                @click="priceAdjustmentCalculation('1')"
                >同意</vButton
            >
            <vButton
                class="margin-right-20 margin-bottom-10"
                theme="error"
                @click="priceAdjustmentCalculation('0')"
                >拒绝</vButton
            >
        </div>
        <compWrapper v-if="type != 'improve'" title="测算信息" theme="primary">
            <compFormQuery
                v-if="querytype == 'query' || querytype == 'priceA'"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-15 clearfix"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <compWrapper
            v-if="querytype == 'query' || querytype == 'priceA'"
            title="测算结果"
            theme="success"
        >
            <compFormQuery
                :formdata="getResultBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            v-if="querytype == 'priceA'"
            title="调价测算结果"
            theme="error"
        >
            <compFormQuery
                :formdata="getPriceABase"
                :value="priceFormData"
                :labelWidth="120"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            v-if="
                querytype == 'query' ||
                type == 'improve' ||
                querytype == 'priceA'
            "
            title="产品资料"
            theme="info"
        >
            <compFormQuery
                v-if="querytype == 'query' || querytype == 'priceA'"
                :formdata="getImproveBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-15 clearfix"
                ref="improveform"
                :formdata="getImproveBase"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <compWrapper title="产品信息" theme="warning">
            <compProduct
                :productformdata="productFormData"
                :alltype="querytype"
                ref="refProduct"
                @open-erp-modal="handleOpenErpModal"
            ></compProduct>
        </compWrapper>
        <!-- ERP SKU 选择弹框 -->
        <vModal
            v-model="erpModal.visible"
            title="选择ERP SKU"
            width="1000"
            :footer-hide="true"
        >
            <compErpsku @on-data="handleErpDataSelected"></compErpsku>
        </vModal>
        <compWrapper
            v-if="querytype == 'query' || querytype == 'priceA'"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
        >
            <vTableSimple
                v-if="querytype == 'query' || querytype == 'priceA'"
                class="margin-15"
                :columns="getColumns"
                :data="getData"
                border
            ></vTableSimple>
        </compWrapper>
        <div
            v-if="querytype != 'query' && querytype != 'priceA'"
            class="text-right margin-right-15"
        >
            <vButton
                v-if="this.type != 'improve'"
                class="margin-right-20"
                theme="info"
                @click="submit('0')"
                >{{
                    $t("fbb.inbound.save_draft", {
                        defaultValue: "保存为草稿",
                    })
                }}</vButton
            >
            <vButton
                v-if="this.type != 'improve'"
                class="margin-right-20"
                theme="primary"
                @click="submit('1')"
                >{{
                    $t("fbb.alloment.save_and_commit", {
                        defaultValue: "保存并提交",
                    })
                }}</vButton
            >
            <vButton
                v-if="this.type == 'improve'"
                class="margin-right-20"
                theme="primary"
                @click="submit('4')"
                >确定</vButton
            >
            <vButton class="margin-right-20" @click="cancel">{{
                $t("global.common.operate_cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import compProduct from "./addProduct";
import compErpsku from "./erpsku";
import {
    HttpGetCalculationReleaseOne,
    HttpSaveCalculationRelease,
    HttpGetLogList,
    HttpPriceAdjustmentCompleted,
} from "@/service/products/calculationRelease";
import mixin from "./mixin";
export default {
    mixins: [mixin],
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compProduct,
        compErpsku,
    },
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            isAdmin: this.$route.params.isAdmin,
            formData: {},
            priceFormData: {},
            productFormData: {},
            logList: [],
            statusIndex: 0,
            loading: false,
            erpModal: {
                visible: false,
                currentRow: null,
                currentIndex: null,
            },
        };
    },
    created() {
        this.update();
    },
    computed: {
        getStatus() {
            return this.statusList.concat().splice(0, 8);
        },
        getBase() {
            return [
                {
                    label: "产品名",
                    key: "productName",
                    required: false,
                },
                {
                    label: "型号",
                    key: "productCode",
                    required: false,
                },
                {
                    label: "状态",
                    key: "status",
                    show: this.type == "query" || this.type == "priceA",
                    tag: "vSelect",
                    options: this.statusList,
                },
                {
                    label: "调价状态",
                    key: "adjustStatus",
                    show:
                        (this.type == "query" || this.type == "priceA") &&
                        this.formData.adjustStatus !== 0,
                    tag: "vSelect",
                    options: this.adjustStatusList,
                },
                {
                    label: "业务模式",
                    key: "businessModel",
                    tag: "vSelect",
                    options: [
                        {
                            value: 0,
                            label: "DF",
                        },
                        {
                            value: 1,
                            label: "PO",
                        },
                    ],
                },
                {
                    label: "ASIN",
                    key: "asin",
                },
                {
                    label: "FOB",
                    key: "fob",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "DDP",
                    key: "ddp",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "期望VC售价",
                    key: "expectVcPrice",
                    tag: "vInputNumber",
                    show: this.type != "query" && this.type != "priceA",
                    span: 12,
                },
                {
                    label: "期望VC售价",
                    key: "expectVcPrice",
                    show: this.type == "query" || this.type == "priceA",
                    render: (h) => {
                        // 改为箭头函数
                        if (this.formData.adjustVcPrice) {
                            return (
                                <span class="margin-right-15">
                                    {this.formData.expectVcPrice}
                                    <span style="color: red;font-weight: bold;">
                                        ( {this.formData.adjustVcPrice} )
                                    </span>
                                </span>
                            );
                        } else {
                            return (
                                <span class="margin-right-15">
                                    {this.formData.expectVcPrice}
                                </span>
                            );
                        }
                    },
                },
                {
                    label: "期望VC采购价",
                    key: "expectPurchasePrice",
                    tag: "vInputNumber",
                    show: this.type != "query" && this.type != "priceA",
                    span: 12,
                    required: false,
                },
                {
                    label: "期望VC采购价",
                    key: "expectPurchasePrice",
                    show: this.type == "query" || this.type == "priceA",
                    render: (h) => {
                        // 改为箭头函数
                        if (this.formData.adjustPurchasePrice) {
                            return (
                                <span class="margin-right-15">
                                    {this.formData.expectPurchasePrice}
                                    <span style="color: red;font-weight: bold;">
                                        ( {this.formData.adjustPurchasePrice} )
                                    </span>
                                </span>
                            );
                        } else {
                            return (
                                <span class="margin-right-15">
                                    {this.formData.expectPurchasePrice}
                                </span>
                            );
                        }
                    },
                },
                {
                    label: "Amazon日常售价",
                    key: "amazonPrice",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "实际关税税负率",
                    key: "negativeTariffRate",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "预估头程物流费",
                    key: "firstShippingFee",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "预估尾程物流费",
                    key: "finalShippingFee",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "SC广告花费占比",
                    key: "scAdvertisingExpenditure",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "退货率",
                    key: "returnRate",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "ACOS",
                    key: "acos",
                    tag: "vInputNumber",
                    span: 12,
                    required: false,
                },
                {
                    label: "CVR",
                    key: "cvr",
                    tag: "vInputNumber",
                    span: 12,
                    required: false,
                },
                {
                    label: "CTR",
                    key: "ctr",
                    tag: "vInputNumber",
                    span: 12,
                    required: false,
                },
                {
                    label: "装箱量",
                    key: "packingQuantity",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "箱/托",
                    key: "boxPallet",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "40HQ整柜装箱量",
                    key: "boxQuantity",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "仓库布局",
                    key: "warehouseLayout",
                },
            ];
        },
        getResultBase() {
            return [
                {
                    label: "店铺",
                    key: "channelFlag",
                },
                {
                    label: "Vendor Code",
                    key: "vendorCode",
                },
                {
                    label: "销售价",
                    key: "sellingPrice",
                },
                {
                    label: "供货价",
                    key: "supplyPrice",
                },
                {
                    label: "广告投入",
                    key: "advertisingInvestment",
                },
                {
                    label: "退货占比",
                    key: "returnProportion",
                },
                {
                    label: "客户最终回款",
                    key: "paymentCollection",
                },
                {
                    label: "运费预估",
                    key: "freightEstimation",
                },
                {
                    label: "amazon利润占比",
                    key: "amazonProfit",
                },
                {
                    label: "客户利润占比",
                    key: "customerProfit",
                },
                {
                    label: "Term",
                    key: "term",
                },
                {
                    label: "附件",
                    key: "attachment",
                    render: (h) => {
                        const row = this.formData;
                        if (row.attachment) {
                            try {
                                let attachment = JSON.parse(row.attachment);
                                let att = [];
                                attachment.map((item) => {
                                    att.push(
                                        h("div", [
                                            h(
                                                "a",
                                                {
                                                    attrs: {
                                                        href: item.attachUrl,
                                                        target: "_blank",
                                                    },
                                                },
                                                item.attachTitle
                                            ),
                                        ])
                                    );
                                });
                                return h("div", att);
                            } catch (error) {
                                return h("div", "附件解析错误");
                            }
                        } else {
                            return h("div", "无");
                        }
                    },
                },
            ];
        },
        getPriceABase() {
            return [
                {
                    label: "店铺",
                    key: "channelFlag",
                },
                {
                    label: "Vendor Code",
                    key: "vendorCode",
                },
                {
                    label: "销售价",
                    key: "sellingPrice",
                },
                {
                    label: "供货价",
                    key: "supplyPrice",
                },
                {
                    label: "广告投入",
                    key: "advertisingInvestment",
                },
                {
                    label: "退货占比",
                    key: "returnProportion",
                },
                {
                    label: "客户最终回款",
                    key: "paymentCollection",
                },
                {
                    label: "运费预估",
                    key: "freightEstimation",
                },
                {
                    label: "amazon利润占比",
                    key: "amazonProfit",
                },
                {
                    label: "客户利润占比",
                    key: "customerProfit",
                },
                {
                    label: "Term",
                    key: "term",
                },
                {
                    label: "附件",
                    key: "attachment",
                    render: (h) => {
                        const row = this.priceFormData;
                        if (row.attachment) {
                            try {
                                let attachment = JSON.parse(row.attachment);
                                let att = [];
                                attachment.map((item) => {
                                    att.push(
                                        h("div", [
                                            h(
                                                "a",
                                                {
                                                    attrs: {
                                                        href: item.attachUrl,
                                                        target: "_blank",
                                                    },
                                                },
                                                item.attachTitle
                                            ),
                                        ])
                                    );
                                });
                                return h("div", att);
                            } catch (error) {
                                return h("div", "附件解析错误");
                            }
                        } else {
                            return h("div", "无");
                        }
                    },
                },
            ];
        },
        getData() {
            return this.logList;
        },
        getColumns() {
            return [
                {
                    title: this.$t("global.common.operate_time"),
                    key: "createdAt",
                    width: 150,
                },
                {
                    title: this.$t("global.common.operator"),
                    key: "createdName",
                    width: 120,
                },
                {
                    title: this.$t("global.common.operate_remark", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                    width: 500,
                },
                {
                    title: "附件",
                    key: "attachment",
                    render: (h, { row }) => {
                        if (row.attachment) {
                            let attachment = JSON.parse(row.attachment);
                            let att = [];
                            attachment.map((item) => {
                                att.push(
                                    <div style="padding: 5px 0;">
                                        <a
                                            href={item.attachUrl}
                                            target="_blank"
                                        >
                                            {item.attachTitle}
                                        </a>
                                    </div>
                                );
                            });
                            return <div style="padding: 5px 0;">{att}</div>;
                        } else {
                            return (
                                <div style="padding: 10px 0;">
                                    <span>无</span>
                                </div>
                            );
                        }
                    },
                },
            ];
        },
        getImproveBase() {
            return [
                {
                    label: "ASIN",
                    key: "asin",
                    show: this.type != "query",
                },
                {
                    label: "FOB(USD)",
                    key: "fob",
                    show: this.type != "query",
                },
                {
                    label: "SELLERSKU",
                    key: "sellerSku",
                },
                {
                    label: "父ASIN",
                    key: "fatherAsin",
                },
                {
                    label: "Listing中文名称",
                    key: "listingName",
                },
                {
                    label: "UPC",
                    key: "upc",
                },
                {
                    label: "最小销售单位",
                    key: "smallSalesUnit",
                    tag: "vSelect",
                    options: this.smallSalesUnitList,
                },
            ];
        },
    },
    methods: {
        // 处理打开ERP弹框
        handleOpenErpModal(params) {
            this.erpModal.currentRow = params.row;
            this.erpModal.currentIndex = params.index;
            this.erpModal.visible = true;
        },
        // 处理ERP数据选择
        handleErpDataSelected(selectedRow) {
            // 调用子组件的方法更新数据
            if (
                this.$refs.refProduct &&
                this.$refs.refProduct.handleErpSelection
            ) {
                this.$refs.refProduct.handleErpSelection(
                    selectedRow,
                    this.erpModal.currentRow,
                    this.erpModal.currentIndex
                );
            }

            // 关闭弹框
            this.erpModal.visible = false;
        },
        async update() {
            if (this.type == "add") return;
            if (this.activeids) {
                this.id = this.activeids;
                this.type = this.querytype;
            }
            if (this.type == "improve") {
                this.querytype = this.type;
            }
            if (this.type == "query" || this.type == "priceA") {
                // 请求操作历史
                HttpGetLogList({
                    search: {
                        EQ_opDataId: this.id,
                    },
                    rows: 1000,
                }).then((res) => {
                    this.logList = res.data.content;
                });
            }
            HttpGetCalculationReleaseOne({
                id: this.id,
            }).then(
                (res) => {
                    this.handleResponse(res.data);
                    this.formData = res.data;
                    this.priceFormData = res.data.productEntity;
                },
                (err) => {}
            );
        },
        handleResponse(data) {
            if (data.adjustStatus == 1 || data.adjustStatus == 2) {
                this.statusIndex = 4;
            } else if (data.status == 7) {
                this.statusIndex = 5;
            } else if (data.status == 5) {
                this.statusIndex = 6;
            } else if (data.status == 6) {
                this.statusIndex = 7;
            } else {
                this.statusIndex = data.status;
            }
            this.$set(this.$data, "productFormData", data || {});
        },
        async submit(status) {
            if (this.type != "improve") {
                let bool3 = await this.$refs.editform.validate();
                if (!bool3) {
                    return;
                }
            } else {
                let bool = await this.$refs.improveform.validate();
                if (!bool) {
                    return;
                }
            }
            let refProduct = this.$refs.refProduct;
            window.console.log("refProduct.formList", refProduct.formList);
            if (refProduct.formList.length > 0) {
                let flag = false;
                refProduct.formList.map((item) => {
                    if (
                        this.type == "improve" &&
                        (item.erpSku === "" ||
                            item.releaseProductName === "" ||
                            item.releaseProductEn === "")
                    ) {
                        flag = true;
                    }
                    if (
                        item.innerBoxLength === undefined ||
                        item.innerBoxWidth === undefined ||
                        item.innerBoxHeight === undefined ||
                        item.outerBoxLength === undefined ||
                        item.outerBoxWidth === undefined ||
                        item.outerBoxHeight === undefined ||
                        item.pieceWeight === undefined ||
                        item.boxWeight === undefined
                    ) {
                        flag = true;
                    }
                });
                if (flag) {
                    this.$Message.error("产品信息table中带*号的必须填写");
                    return;
                }
            }
            this.formData.isImprove = this.type == "improve" ? 1 : 0;
            this.formData.detailEntities = refProduct.formList;
            this.formData.status = status;
            this.loading = true;
            HttpSaveCalculationRelease({
                ...this.formData,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        async priceAdjustmentCalculation(status) {
            this.formData.isPriceAdjustment = status;
            this.loading = true;
            HttpPriceAdjustmentCompleted({
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.loading = false;
                    this.$emit("on-close");
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            if (this.$route.name === "calculationReleaseList") {
                // 如果是当前路由，刷新页面
                window.location.reload();
            } else {
                // 如果不是当前路由，正常导航
                this.$router.push({
                    name: "calculationReleaseList",
                });
            }
        },
    },
};
</script>
